import { useState, useEffect, useMemo } from "react";
import { getKeywordFilterOptions } from "../../../services/container";
import { groupKeywordFilterOptions } from "../utils/activityPageFilters";

export const useActivityPageFilterOptions = () => {
  const [keywordFilterOptions, setKeywordFilterOptions] = useState([]);

  useEffect(() => {
    getKeywordFilterOptions({
      keywordFilter: JSON.stringify([]),
    }).then((response) => {
      if (response.status === 200) {
        setKeywordFilterOptions(response.data.keywordFilterOptions || []);
      }
    });
  }, []);

  const groupedOptions = useMemo(
    () => groupKeywordFilterOptions(keywordFilterOptions),
    [keywordFilterOptions],
  );

  return {
    groupedOptions,
  };
};
